<app-card>
  <h3>{{ "settings.headline" | translate }}</h3>

  <form class="settings-form" [formGroup]="form">
    <table class="table-fixed transparent">
      <tr>
        <th>{{ "default.language.label" | translate }}</th>
        <td>
          <div class="flex">
            <app-input-wrapper
              isSelect
              [control]="form.controls['selectedLanguage']"
            >
              <select formControlName="selectedLanguage">
                @for (language of supportedLanguages; track language) {
                  <option [value]="language">
                    {{ 'default.language.' + language.toUpperCase() | translate}}
                  </option>
                }
              </select>
            </app-input-wrapper>
          </div>
        </td>
      </tr>
      <tr>
        <th>{{ "default.theme" | translate }}</th>
        <td>
          <div class="flex wrap">
            @for (themeMode of themeModes; track themeMode) {
              <app-input-wrapper [control]="form.controls['themeMode']">
                <input
                  [id]="themeMode"
                  [value]="themeMode"
                  type="radio"
                  name="themeMode"
                  formControlName="themeMode"
                />
                <label [for]="themeMode">
                  {{ "default.themeModes." + themeMode | translate }}
                </label>
              </app-input-wrapper>
            }
          </div>
        </td>
      </tr>
    </table>
  </form>
</app-card>
